import React from "react";
import PropTypes from "prop-types";

Step.propTypes = {
  data: PropTypes.array,
};

function Step(props) {
  const { data } = props;
  return (
    <section className="tf-section three_step">
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="wrap-box">
              {data.map((item) => (
                <div key={item.id} className="icon-box-style3">
                  <div className="icon">
                    <img src={item.img} alt="" />
                  </div>
                  <div className="content">
                    <h5 className="title">{item.title}</h5>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6">
            <div className="image pt30" style={{ transform: "scale(1.5)" }}>
              <img
                src={require("../../assets/images/common/Big grey pic.webp")}
                className="move5"
                alt="hands"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Step;
